import gql from 'graphql-tag';

import { IMAGE_OVERLAY_TEXT_FIELD } from 'src/data/image';
import { CUSTOMER_PERSONA_FRAGMENT } from 'src/graphql/customerPersona/schema';

export const FRAGMENT_CONTENT_VALIDATION = gql`
  fragment ContentValidation on ContentValidation {
    label
    reason
    reasonDetails
  }
`;

export const FRAGMENT_AB_TEST = gql`
  fragment AbTest on AbTest {
    name
    value
  }
`;

export const FRAGMENT_TARGET_AUDIENCE_INSIGHTS = gql`
  fragment TargetAudienceInsights on TargetAudienceInsights {
    score
    persona {
      ...CustomerPersona
    }
  }
  ${CUSTOMER_PERSONA_FRAGMENT}
`;

export const FRAGMENT_TARGET_AUDIENCE_INSIGHTS_DEMOGRAPHICS = gql`
  fragment TargetAudienceInsightsDemographics on TargetAudienceInsightsDemographics {
    audienceScores {
      ...TargetAudienceInsights
    }
    ageScoreHistogram
    genderScoreHistogram
  }
  ${FRAGMENT_TARGET_AUDIENCE_INSIGHTS}
`;

export const FRAGMENT_CONTENT_MARKUP = gql`
  fragment ContentMarkup on ContentMarkup {
    type
    paragraph
    start
    end
  }
`;

export const FRAGMENT_IMAGE_OVERLAY_TEXT = gql`
  fragment ImageOverlayText on ImageOverlayTextType {
    ${IMAGE_OVERLAY_TEXT_FIELD.headline}
    ${IMAGE_OVERLAY_TEXT_FIELD.subHeadline}
    ${IMAGE_OVERLAY_TEXT_FIELD.cta}
  }
`;
